var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTarget = function SvgTarget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.988c5.53 0 10.012 4.483 10.012 10.012S17.529 22.012 12 22.012 1.99 17.529 1.988 12C1.988 6.47 6.471 1.989 12 1.988m0 1.2a8.813 8.813 0 0 0 0 17.624 8.812 8.812 0 0 0 0-17.624m0 2.565a6.247 6.247 0 1 1 0 12.494 6.247 6.247 0 0 1 0-12.494m0 1.2A5.048 5.048 0 1 0 17.047 12 5.05 5.05 0 0 0 12 6.951m0 2.565a2.483 2.483 0 1 1 0 4.965 2.483 2.483 0 0 1 0-4.965m0 1.199A1.284 1.284 0 1 0 13.282 12c0-.708-.574-1.283-1.282-1.283"
  })));
};
export default SvgTarget;